import { EventActionNodeType } from '../../types'
import { Tooltip } from '@/ui'
import { Menu, MenuItem } from '@dashboard/ui'
import { getNodeIcon } from '../../icons'
import { LinkBrokenIcon } from '../../icons/LinkBrokenIcon'
import { isIntegrationRequire } from '../../util'
import { useTranslation } from 'react-i18next'
import { Popover } from '@mui/material'

export const SelectActionNode = (props: {
  onClose: () => void
  onSelect: (value: EventActionNodeType) => void
  anchorEl: HTMLElement
  actions: EventActionNodeType[]
}) => {
  const { t } = useTranslation()

  return (
    <Popover
      className="mt-1"
      elevation={1}
      open={true}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <>
        <div className="w-[380px] border-b border-border-secondary p-3">
          <p className="text-title-t6">{t('campaign.editor.select-block-type')}</p>
        </div>

        <Menu
          className="w-full max-w-none border-none p-0"
          motionProps={{ className: 'rounded-none border-none w-full p-0' }}
          fullWidth={true}
          datatestid="select-action"
          maxHeight={'80vh'}
        >
          {props.actions
            .filter(it => it != EventActionNodeType.GraphRoot)
            .map(it => (
              <MenuItem data-testid={`select-action/${it}`} onClick={() => props.onSelect(it)} key={it}>
                <div className="flex items-center gap-3">
                  {getNodeIcon(it)}
                  {t(`campaign.node-type.${it}`)}
                  {isIntegrationRequire(it) && (
                    <Tooltip message={t('campaign.editor.integration-require')}>
                      <LinkBrokenIcon style={{ marginLeft: 'auto', opacity: 0.8 }} />
                    </Tooltip>
                  )}
                </div>
              </MenuItem>
            ))}
        </Menu>
      </>
    </Popover>
  )
}
